import React, { Component } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import "./Tooltip.scss";

class Tooltip extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tooltipPos: undefined,
			show: false,
		};
	}

	showTooltip = e => {
		e.persist();
		const { tooltipPos } = this.state;
		const { placement } = this.props;
		this.setState({ show: true }, () => {
			const tooltip = document.querySelectorAll(".tooltip-default")[0];
			const tWidth = tooltip.offsetWidth;
			const tHeight = tooltip.offsetHeight;
			const pWidth = e.target.offsetWidth;
			const pHeight = e.target.offsetHeight;
			if (!tooltipPos) {
				const { left } = e.target.getBoundingClientRect();
				const { top } = e.target.getBoundingClientRect();
				// Caculate tooltip positioning relative to the element triggering the event and its placement
				switch (placement) {
					case "top":
						this.setState({
							tooltipPos: {
								top: Math.abs(top + window.scrollY - tHeight),
								left: left - (tWidth / 2 - pWidth / 2),
							},
						});
						break;
					case "left":
						this.setState({
							tooltipPos: {
								top: Math.abs(top + window.scrollY - tHeight / 2.5),
								left: left - tWidth,
							},
						});
						break;
					case "bottom":
						this.setState({
							tooltipPos: {
								top: Math.abs(top + window.scrollY + pHeight),
								left: left - (tWidth / 2 - pWidth / 2),
							},
						});
						break;
					case "right":
						this.setState({
							tooltipPos: {
								top: Math.abs(top + window.scrollY - tHeight / 2.5),
								left: left + tWidth / 10,
							},
						});
						break;
					default:
						break;
				}
			}
		});
	};

	hideTooltip = e => {
		e.stopPropagation();
		this.setState({ tooltipPos: undefined, show: false });
	};

	Tooltip = () => {
		const { placement, content } = this.props;
		const { tooltipPos, show } = this.state;
		return (
			<div
				role="tooltip"
				data-toggle="tooltip"
				data-placement={placement}
				style={tooltipPos}
				className={`fade${show ? " in" : ""} tooltip-default tooltip ${placement}`}
			>
				<div className="tooltip-arrow" />
				<div className="tooltip-inner text-left">{content}</div>
			</div>
		);
	};

	render() {
		const { id, className, children } = this.props;
		const { show } = this.state;
		return (
			<span
				id={id}
				className={`rk-tooltip${className ? ` ${className}` : ""}`}
			>
				{/* Clone children in order to add event handlers directly to the child element */}
				{React.cloneElement(children, {
					onMouseEnter: e => this.showTooltip(e),
					onMouseLeave: e => this.hideTooltip(e),
					onFocus: e => this.showTooltip(e),
					onBlur: e => this.hideTooltip(e),
				})}
				{/* Append tooltip to the DOM body */}
				<If condition={show}>{createPortal(<this.Tooltip />, document.body)}</If>
			</span>
		);
	}
}

Tooltip.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
	placement: PropTypes.oneOf(["top", "left", "bottom", "right"]),
	content: PropTypes.string,
};

Tooltip.defaultProps = {
	id: undefined,
	className: undefined,
	placement: "top",
	content: "",
};

export default Tooltip;
